import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import UpdateDeliverySlot from '../UpdateDeliverySlot/UpdateDeliverySlot';
import { myDeliveries, changeHandler, validateHandler, deliveryCallBack } from './UpdateDeliverySlotHolderSlice';
import { backToDeliveries, endProcess } from '../UpdateDeliverySlot/UpdateDeliverySlotSlice';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import Image from 'app/Components/Shared/Image/image';
const updateDeliverySlotHolder = (props) => {
  const isIDFCustomer = props.roleList?.some(role => role.startsWith('IDFOTP')) ?? false;
  const NoDeliveryFoundContact = isIDFCustomer ? '999' : '0058'
  useEffect(() => {
    gaEvent(gaParams.DELIVERY_SLOT_START.category, gaParams.DELIVERY_SLOT_START.eventType, gaParams.DELIVERY_SLOT_START.eventParams);
    if (props.isFullAuthenticated || props.isOtpExtendedAuthenticated) {
      if (!props.myDeliveriesList.items) {
        props.showAppLoader();
        props.myDeliveries();
      }
    }
    return () => {
      props.endProcess();
    };
  }, []);

  useEffect(() => {
    if (props.isShowFail) {
      props.hideAppLoader();
      gaEvent(gaParams.DELIVERY_UPDATE_FAIL.category, gaParams.DELIVERY_UPDATE_FAIL.eventType, gaParams.DELIVERY_UPDATE_FAIL.eventParams);
    }
  }, [props.isShowFail]);

  useEffect(() => {
    if (props.form.valid) {
      props.showAppLoader();
      createCallback(props);
    }
  }, [props.form.valid]);

  useEffect(() => {
    if (props.isNoDeliveries == true) {
      gaEvent(gaParams.DELIVERY_NOT_FOUND.category, gaParams.DELIVERY_NOT_FOUND.eventType, gaParams.DELIVERY_NOT_FOUND.eventParams);
      props.hideAppLoader();
    }
  }, [props.isNoDeliveries]);

  const callSupportClicked = () => {
    gaEvent(gaParams.DELIVERY_CALL_SUPPORT.category, gaParams.DELIVERY_CALL_SUPPORT.eventType, gaParams.DELIVERY_CALL_SUPPORT.eventParams);
  };

  const checkNoteOrder = () => {
    let noteOrderArr = [];
    props.myDeliveriesList.items.map(function (item, index) {
      noteOrderArr[index] = { idx: index, noteOrder: item.noteOrder };
    });
    let sameNoteOrder;
    if (noteOrderArr.length > 1) {
      sameNoteOrder = noteOrderArr.reduce((unique, o) => {
        if (!unique.some((obj) => obj.noteOrder != o.noteOrder)) {
          unique.push(o);
        }
        return unique;
      }, []);
      return sameNoteOrder;
    } else {
      return (sameNoteOrder = false);
    }
  };

  const checkForDeliveries = () => {
    try {
      return (
        <div className='deliveries-not-found'>
          {props.isNoDeliveries ? (
            <div>
              אוי, נראה שאין פה אף אחד על הטוסטוס
              <br></br>
              אם בכל זאת אמורה להגיע אליכם שליחות מוזמנים להתקשר ל- {NoDeliveryFoundContact}*
              <br></br>
              בשעות הפעילות:
              <br></br>
              א-ה 8:00-16:00
              <br></br>
              ו' וערבי חג 8:00-13:00
            </div>
          ) : (
            props.myDeliveriesList.items.map(function (item, index) {
              return (
                <Col key={index}>
                  <UpdateDeliverySlot
                    data={item}
                    idx={index}
                    slotsCount={props.myDeliveriesList.items.length}
                    sameNoteOrders={checkNoteOrder()}
                  />
                </Col>
              );
            })
          )}
        </div>
      );
    } catch {
      return null;
    }
  };

  const deliveryUpdateFail = () => {
    return (
      <Row>
        <Col>
          {props.isShowErrorPage ? (
            <>
              <p className='response-title'>מצטערים, אי אפשר להשלים את הפעולה דרך האתר</p>
              <p className='delivery-text'>אבל דרך נציגי השירות שלנו לגמרי כן והם ישמחו לעזור</p>
              <div className='delivery-man-img'>
                <Image src={require('./images/icons-error.svg')} alt='כישלון'/>
              </div>
              <Row>
                <Col className='submit-CallBack'>
                  <a className='call-service-center' href='tel:050000000' onClick={() => callSupportClicked()}>
                    <Image src={require('./images/icons-call-phone.svg')} alt='דבר איתנו'/>
                    <div> דברו איתנו</div>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col className='work-hours'>
                  <p>
                    {props.iContent.workHours.value}
                    <br></br>
                    {props.iContent.workHoursShort.value}
                  </p>
                </Col>
              </Row>
              <div className='back-personal-area' onClick={() => EpiContext.navigateTo(Config.lobbyUrl)}>
                <span>חזרה לאזור האישי</span>
              </div>
            </>
          ) : (
            showCallBackResponse()
          )}
        </Col>
      </Row>
    );
  };

  return (
    <Container className='delivery-slot-container'>
      <Row className='delivery-slot-holder'>
        <Col>
          <Row>
            <Col>
              <p className='delivery-due'>סטטוס ועדכון שליחות</p>
            </Col>
          </Row>
          {props.isShowFail == true ? (
            deliveryUpdateFail()
          ) : (
            <div>
              <Row>
                <Col>
                  <p className='delivery-title'>מתי נפגשים?</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className='delivery-text'>כאן תוכלו לראות למתי מתואמת לכם שליחות ולעדכן את המועד שלה</p>
                </Col>
              </Row>
              <Row>
                <Col className='delivery-man-img'>
                  <Image src={require('./images/delivery.svg')} alt='שליח'></Image>
                </Col>
              </Row>
              <Row>
                <Col className='slots-container'>
                  <Row>
                    <Col>
                      <div>{checkForDeliveries()}</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    myDeliveriesList: state.updateDeliverySlotHolder.myDeliveriesList,
    isNoDeliveries: state.updateDeliverySlotHolder.isNoDeliveries,
    isShowFail: state.updateDeliverySlot.isShowFail,
    updateSuccess: state.updateDeliverySlot.updateSuccess,
    form: state.updateDeliverySlotHolder.form,
    isCallBackSuccess: state.updateDeliverySlotHolder.isCallBackSuccess,
    isCallBackFail: state.updateDeliverySlotHolder.isCallBackFail,
    isShowErrorPage: state.updateDeliverySlotHolder.isShowErrorPage,
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    isOtpExtendedAuthenticated: state.authentication.loginData.isOtpExtendedAuthenticated,
    roleList: state.authentication.loginData?.userDetails?.RoleList
  };
};

const mapDispatchToProps = {
  myDeliveries,
  changeHandler,
  validateHandler,
  showAppLoader,
  hideAppLoader,
  deliveryCallBack,
  backToDeliveries,
  endProcess,
};

export default connect(mapStateToProps, mapDispatchToProps)(updateDeliverySlotHolder);
